import { TransactionsTable, useTransactionsList } from "modules/financial";
import { useParams } from "react-router-dom";
import { Pagination, SearchInput } from "ui";

import styles from "./ResellerPayments.module.scss";

const ResellerPayments = () => {
  const { resellerId } = useParams();

  const {
    transactions,
    isLoading,
    searchValue,
    setSearchValue,
    sorting,
    setSorting,
    page,
    setPage,
    totalItems
  } = useTransactionsList(resellerId);

  return (
    <div className={styles.resellerPayments}>
      <SearchInput
        value={searchValue}
        onChange={setSearchValue}
        placeholder="Search..."
      />

      <div className={styles.resellerOrders_table}>
        <TransactionsTable
          transactions={transactions ?? []}
          sorting={sorting}
          setSorting={setSorting}
          isLoading={isLoading}
          asResellerPayments
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default ResellerPayments;
